module.exports = require("./es-UY.js");